<div class="col-md-12 pageTitle">
  <label class="pt-4 pl-4">Manage User Access</label>
</div>

<div class="col-md-12">
  <div class="container mt-4">
    <div class="row col-md-12 justify-content-end mb-2">
      <button class="btn btn-success button" (click)="addNewItem()"><em class="fa fa-plus"
          *ngIf="isEditEnabled"></em>&nbsp;&nbsp;&nbsp;
        Add New User</button>
    </div>
    <div class="table-responsive">
      <table class="table table-hover table-bordered">
        <thead class="turTable">
          <tr class="">
            <th class="cellHeader">Name</th>
            <th class="cellHeader">Email</th>
            <th class="cellHeader">Status</th>
            <th class="cellHeader">Created By</th>
            <th class="cellHeader">Role</th>
            <th class="cellHeader text-center action">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of internalUserList">
            <td class="cellValue">{{item?.name}}</td>
            <td class="cellValue">{{item?.email_id}}</td>
            <td class="cellValue">{{item?.status}}</td>
            <td class="cellValue">{{item?.created_by?.name}}</td>
            <td class="cellValue">{{item?.role}}</td>
            <td class="cellValue text-center">
              <button class="payBlue btn" (click)="editLead(item)" *ngIf="isEditEnabled">Edit Name</button>
              <button class="payBlue btn" (click)="editRole(item)" *ngIf="isEditEnabled">Update Role</button>
              <button class="remindBlack btn" (click)="updateStatus(item,'INACTIVE')" *ngIf="isEditEnabled && item.status==='ACTIVE'">Deactivate</button>
              <button class="invoiceTur btn" (click)="updateStatus(item,'ACTIVE')" *ngIf="isEditEnabled && item.status!=='ACTIVE'">Activate</button>
              <button class="darkGreenBtn btn" (click)="changePassword(item)" *ngIf="isEditEnabled">Change Password</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent($event)">
    </mat-paginator>
  </div>
</div>
